import React from 'react';

import { LocaleContext } from '../translations/LocaleContext'
import { LanguageCode } from '../translations';

interface Props {
    languageCode: LanguageCode
}

export const LocaleProvider: React.FC<Props> = ({ languageCode, children }) => {
    const [locale, setLocale] = React.useState(languageCode)    
    return <LocaleContext.Provider value={{ locale, setLocale }}>{children}</LocaleContext.Provider>
}